module.exports = __webpack_public_path__ + "img/Left-top.95cff950.svg";